export type NameType = 'mqDown';

export const name: NameType = 'mqDown';
